import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { fetchCouponUsagesByTenant } from '../repositories/coupons.js';
import { buildUserCouponActivityMap, type UserCouponActivity } from '../couponStats.js';

/**
 * テナント全体の coupon_usages から lineUserId → クーポン横断アクティビティ
 * （取得 / 使用の有無と直近日時）を組み立てる hook（M-68 / 顧客一覧用）。
 *
 * cache key: `['promo', 'couponUsagesByTenant', tenantId]`（raw を保持し select で集約）
 * - バッジの日付プレフィックス（`MM/DDクーポン利用` 等）と、行動アクションフィルターの
 *   和集合判定（eventTypeCounts に無い過去の取得・使用も掛ける）の両方に使う。
 * - tenantId が null/undefined の間は disabled。
 */
export function useCouponUsageActivity(
  tenantId: string | null | undefined,
): UseQueryResult<Map<string, UserCouponActivity>, Error> {
  return useQuery({
    queryKey: ['promo', 'couponUsagesByTenant', tenantId],
    queryFn: () => fetchCouponUsagesByTenant(tenantId as string),
    select: buildUserCouponActivityMap,
    enabled: !!tenantId,
    staleTime: 60 * 1000,
  });
}
